import React from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { usePathLanguage } from "../hooks/usePathLanguage";

function LanguageDisclaimer({ modalOpen, closeModal, lng }) {
  const { t } = useTranslation();
  const pathLanguage = usePathLanguage();

  return (
    <Modal
      size="lg"
      centered="true"
      show={modalOpen}
      onHide={closeModal}
      backdrop={false}
      className="bob_modal bob_modal1 product_modal our_brand_inner card_round"
    >
      <Modal.Body>
        <Modal.Header closeButton></Modal.Header>
        <Row>
          <Col md={12} className="d-flex align-items-center">
            <h2 className="grad-heading pd-5 m-0">
              {t("home.disclaimer.title")}
            </h2>
          </Col>
          <Col md={12}>
            <div className="d-flex align-item-center">
              <article className="p-4">
                <p>
                  This page is intentionally kept in English. You can either
                  continue viewing this page in English or return to the
                  previous page.
                  {/* {t("home.disclaimer.english_language_retained")}{" "} */}
                  {/* <a href="javascript:void(0)" onClick={closeModal}>
                    {t("home.disclaimer.english_continue")}
                  </a> */}
                </p>

                <p>
                  {/* {t("home.disclaimer.english_language_retained_inHindi")}{" "}
                  <a href="/hindi/" onClick={closeModal}>
                    {t("home.disclaimer.hindiButton")}
                  </a>{" "}
                  या इस{" "}
                  <a href="javascript:void(0)" onClick={closeModal}>
                    {t("home.disclaimer.englishView")}
                  </a> */}
                  यह पेज जानबूझकर अंग्रेजी में रखा गया है। आप चाहें तो इसे
                  अंग्रेजी में ही देख सकते हैं या पिछले पेज पर वापस जा सकते हैं।
                </p>

                <p>
                  આ પેજ જાણી જોઈને અંગ્રેજીમાં રાખવામાં આવ્યું છે. તમે આ પેજને
                  અંગ્રેજીમાં જોવાનું ચાલુ રાખી શકો છો અથવા પાછલા પેજ પર પાછા જઈ
                  શકો છો.
                  {/* {t("home.disclaimer.english_language_retained_inGujarati")}{" "}
                  <a href="/gu/" onClick={closeModal}>
                    {t("home.disclaimer.gujaratiButton")}
                  </a>{" "}
                  અથવા આ{" "}
                  <a href="javascript:void(0)" onClick={closeModal}>
                    {t("home.disclaimer.englishViewgu")}
                  </a> */}
                </p>

                <p>
                  हे पेज जाणीवपूर्वक इंग्रजीमध्ये ठेवण्यात आले आहे. आपण हे पेज इंग्रजीतच पाहू शकता किंवा मागील पेजवर परत जाऊ शकता.
                </p>
              </article>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default LanguageDisclaimer;
